import { useSelector } from '@xstate/react';
import { UserContext } from '~/app';
import { useOpportunitiesMachineService } from '~/features/shared/useOpportunitiesMachineService';
import { jobOpportunitiesMachine } from './jobOpportunities.machine';

export const useJobOpportunitiesService = () => {
  const userRef = UserContext.useActorRef();
  const providerId = useSelector(userRef, (s) => s.context.providerId);
  const opportunitiesService = useOpportunitiesMachineService(jobOpportunitiesMachine);

  return {
    providerId,
    ...opportunitiesService,
  };
};
